import {Component, Input, OnInit} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {ControlContainer, NgForm} from '@angular/forms';

@Component({
    selector: 'app-dialog-step2-section-controller',
    templateUrl: './dialog-step2-section-controller.component.html',
    styleUrls: ['./dialog-step2-section-controller.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class DialogStep2SectionControllerComponent extends EditModalSectionBaseComponent implements OnInit {


    @Input() public forceFormValidationVisibility: boolean;

    constructor(public  editModalService: EditModalService) {
        super(editModalService);
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    // public isInternalUser(): boolean {
    //     // return false;
    //     return super.isInternalUser();
    // }

}
